module.exports = __webpack_public_path__ + "media/packs/fonts/UtopiaStd-BlackHeadline-990fd6bb3bb5133479b0429b4eb2ebc0.woff2";